import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import HourRentalBasicRateServices from "services/HourRentalBasicRateServices";
import { notifyError, notifySuccess } from "utils/toast";

const useHourRentalBasicRateSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState(null);
  const [dataInput, setDataInput] = useState([
    {
      vehicle_type_0: "",
      "4h_40km_0": "",
      "6h_60km_0": "",
      "8h_80km_0": "",
      "10h_100km_0": "",
      extra_km_0: "",
      extra_hr_0: "",
      prime_0: "",
    },
  ]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [primeAvailable, setPrimeAvailable] = useState();
  const handleVehicleCategoryChange = (e, index) => {
    const { name, value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();

  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };

  // const handleChangeInput = (e, i) => {
  //   if (e && e.target) {
  //     const { name, value } = e.target;
  //     const onChangeVal = [...dataInput];
  //     onChangeVal[i][name] = value;
  //     setDataInput(onChangeVal);
  //   }
  // };

  const handleChangeInput = (e, i) => {
    if (e && e.target) {
      const { name, value } = e.target;

      const onChangeVal = [...dataInput];
      onChangeVal[i][name] = value;
      setDataInput(onChangeVal);

      // 8H 80KM
      if (name === `8h_80km_${i}`) {
        if (value !== "" && Number(value) < 1000) {
          setError(name, {
            type: "manual",
            message: "8H 80KM must be minimum 1000",
          });
        } else {
          clearErrors(name);
        }
      }

      // 10H 100KM
      if (name === `10h_100km_${i}`) {
        if (value !== "" && Number(value) < 1000) {
          setError(name, {
            type: "manual",
            message: "10H 100KM must be minimum 1000",
          });
        } else {
          clearErrors(name);
        }
      }

      // Extra KM
      if (name === `extra_km_${i}`) {
        if (value !== "" && Number(value) < 10) {
          setError(name, {
            type: "manual",
            message: "Extra KM must be minimum 10",
          });
        } else {
          clearErrors(name);
        }
      }
    }
  };

  const onSubmit = async (data) => {
    let hasError = false;

    for (let i = 0; i < dataInput.length; i++) {
      const eightHour = Number(dataInput[i][`8h_80km_${i}`]);
      const tenHour = Number(dataInput[i][`10h_100km_${i}`]);
      const extraKm = Number(dataInput[i][`extra_km_${i}`]);

      // 8H 80KM
      if (!dataInput[i][`8h_80km_${i}`]) {
        setError(`8h_80km_${i}`, {
          type: "manual",
          message: "8H 80KM is required!",
        });
        hasError = true;
      } else if (eightHour < 1000) {
        setError(`8h_80km_${i}`, {
          type: "manual",
          message: "8H 80KM must be minimum 1000",
        });
        hasError = true;
      } else {
        clearErrors(`8h_80km_${i}`);
      }

      // 10H 100KM
      if (!dataInput[i][`10h_100km_${i}`]) {
        setError(`10h_100km_${i}`, {
          type: "manual",
          message: "10H 100KM is required!",
        });
        hasError = true;
      } else if (tenHour < 1000) {
        setError(`10h_100km_${i}`, {
          type: "manual",
          message: "10H 100KM must be minimum 1000",
        });
        hasError = true;
      } else {
        clearErrors(`10h_100km_${i}`);
      }

      // Extra KM
      if (!dataInput[i][`extra_km_${i}`]) {
        setError(`extra_km_${i}`, {
          type: "manual",
          message: "Extra KM is required!",
        });
        hasError = true;
      } else if (extraKm < 10) {
        setError(`extra_km_${i}`, {
          type: "manual",
          message: "Extra KM must be minimum 10",
        });
        hasError = true;
      } else {
        clearErrors(`extra_km_${i}`);
      }
    }

    // Stop submit if validation failed
    if (hasError) {
      return;
    }

    setLoading(true);

    if (selectedCity.length === 0) {
      notifyError("City is required.");
      setIsSubmitting(false);
      return;
    }
    try {
      const dataValues = {};
      const vehicleTypeValues = dataInput.map((item) =>
        parseInt(item[Object.keys(item)[0]]),
      );

      const Values4h40km = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[1]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const Values6h60km = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[2]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});

      const Values8h80km = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[3]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});

      const Values10h100km = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[4]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});

      const ExtraKMValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[5]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const ExtraHRValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[6]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      const PrimeValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        let value = item[Object.keys(item)[7]];
        value = Number(value).toString();
        accumulator[key] = value;
        return accumulator;
      }, {});
      dataValues.vehicle_type = vehicleTypeValues;
      dataValues["4h_40km"] = Values4h40km;
      dataValues["6h_60km"] = Values6h60km;
      dataValues["8h_80km"] = Values8h80km;
      dataValues["10h_100km"] = Values10h100km;
      dataValues.extra_km = ExtraKMValues;
      dataValues.extra_hr = ExtraHRValues;
      dataValues.prime = PrimeValues;
      dataValues.city = selectedCity;
      setIsSubmitting(true);

      if (id) {
        const res = await HourRentalBasicRateServices.updateHourRentalBasicRate(
          id,
          dataValues,
        );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res =
          await HourRentalBasicRateServices.addHourRentalBasicRate(dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      //closeDrawer();
    } finally {
      setLoading(false);
    }
  };

  const getHourRentalBasicRateData = async () => {
    try {
      const res =
        await HourRentalBasicRateServices.getHourRentalBasicRateById(id);
      if (res) {
        const FormWholeArray = [];
        if (res.vehicle_type_id) {
          res.vehicle_type_id.forEach((item, index) => {
            let obj = {};
            obj["vehicle_type_" + index] = item;
            obj["4h_40km_" + index] = res["4h_40km"][item];
            obj["6h_60km_" + index] = res["6h_60km"][item];
            obj["8h_80km_" + index] = res["8h_80km"][item];
            obj["10h_100km_" + index] = res["10h_100km"][item];
            obj["extra_km_" + index] = res["extra_km"][item];
            obj["extra_hr_" + index] = res["extra_hr"][item];
            if (res.prime !== null) {
              obj["prime_" + index] = res["prime"][item];
            }
            FormWholeArray.push(obj);
          });
        }
        setDataInput(FormWholeArray);
        setSelectedOptions(res.vehicle_type_id);
        setPrimeAvailable(res.prime_available);
        setSelectedCity(res.city);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setDataInput((prevData) =>
        prevData.map((item) => {
          const resetItem = {};
          Object.keys(item).forEach((key) => {
            if (key.match(/_([0-9]+)$/)) {
              resetItem[key] = "";
            } else {
              resetItem[key] = item[key];
            }
          });
          return resetItem;
        }),
      );
      setDataInput([
        {
          vehicle_type_0: "",
          "4h_40km_0": "",
          "6h_60km_0": "",
          "8h_80km_0": "",
          "10h_100km_0": "",
          extra_km_0: "",
          extra_hr_0: "",
          prime_0: "",
        },
      ]);

      setSelectedOptions([]);
      setSelectedCity([]);
      setSelectedCity("");
      clearErrors("city");
      clearErrors();

      return;
    }

    if (id) {
      getHourRentalBasicRateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    handleCityChange,
    selectedCity,
    trigger,
    loading,
    setLoading,
    errors,
    isSubmitting,
    selectedVehicleCategory,
    setSelectedVehicleCategory,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    primeAvailable,
  };
};

export default useHourRentalBasicRateSubmit;
